<template>
    <nuxt-link v-if="showLink" class="d-block text-right" no-prefetch :to="{name: 'supplierProducts'}">
        <strong>{{ $t('full_view') }}</strong>
    </nuxt-link>
    <div :class="{'elevation-1': elevation}">
        <ProductHotels />
    </div>
</template>

<script lang="ts">
    import {Component, mixins, Prop} from 'vue-facing-decorator'
    import ProductHotels from '~src/components/products/hotels/ProductHotels.vue'
    import {AuthInfoMixin} from '~src/mixins/authInfoMixin.src'

    @Component({
        components: {
            ProductHotels,
        },
    })
    export class Contracts extends mixins(AuthInfoMixin) {
        @Prop({default: true}) showLink
        @Prop({default: false, type: Boolean}) elevation

        productTab: string = 'ownHotel'

        async mounted() {
            await supplierStore.loadContentProviders('ACCOMMODATION')
            await supplierStore.loadSuppliersForContract()
        }
    }

    export default Contracts
</script>
